import { useId } from "react";
import { useWorldT } from "../i18n.js";
import { SettingRow, Switch } from "../camera/SettingsParts.js";
import { setLookPrefs, useLookPrefs } from "./prefs.js";

/** Look speed, inverted vertical look and the first-person head bob (this device): sheet rows. */
export function LookSettings() {
  const t = useWorldT();
  const p = useLookPrefs();
  const id = useId();
  return (
    <div className="hud-group" data-testid="world-look">
      <SettingRow
        label={t("nav.sensitivity")}
        hint={t("game.lookHint")}
        value={`${p.sensitivity.toFixed(1)}×`}
        stacked
        htmlFor={id}
      >
        <input
          id={id}
          type="range"
          className="hud-slider"
          min={0.3}
          max={3}
          step={0.1}
          value={p.sensitivity}
          onChange={(e) => setLookPrefs({ sensitivity: Number(e.target.value) })}
          data-testid="world-sensitivity"
        />
      </SettingRow>
      <Switch
        label={t("nav.invertY")}
        hint={t("game.invertHint")}
        checked={p.invertY}
        onChange={(on) => setLookPrefs({ invertY: on })}
        testId="world-invert-y"
      />
      <Switch
        label={t("nav.headBob")}
        hint={t("game.bobHint")}
        checked={p.headBob}
        onChange={(on) => setLookPrefs({ headBob: on })}
        testId="world-head-bob"
      />
    </div>
  );
}
